<script setup lang="ts">
import { ref } from 'vue'

const isOpen = ref(false)
const message = ref('')

const toggleChat = () => {
  isOpen.value = !isOpen.value
}

const sendMessage = () => {
  if (!message.value.trim()) return
  // Handle message sending here
  console.log('Sending message:', message.value)
  message.value = ''
}
</script>

<template>
  <div class="fixed bottom-6 right-6 z-50">
    <!-- Chat Window -->
    <div
      v-if="isOpen"
      class="absolute bottom-20 right-0 w-96 bg-white dark:bg-gray-800 rounded-lg shadow-xl border border-gray-200 dark:border-gray-700 overflow-hidden"
    >
      <!-- Header -->
      <div class="p-4 bg-blue-600 text-white flex items-center justify-between">
        <div class="flex items-center gap-3">
          <div class="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center">
            <span class="text-xl">💬</span>
          </div>
          <div>
            <h3 class="font-semibold">Chat with us</h3>
            <p class="text-sm text-blue-100">We typically reply within minutes</p>
          </div>
        </div>
        <button @click="toggleChat" class="text-white/80 hover:text-white">
          ✕
        </button>
      </div>

      <!-- Chat Messages -->
      <div class="h-96 p-4 overflow-y-auto">
        <!-- Welcome Message -->
        <div class="flex gap-3 mb-4">
          <div class="w-8 h-8 bg-blue-100 dark:bg-blue-900/50 rounded-full flex items-center justify-center flex-shrink-0">
            👋
          </div>
          <div class="bg-gray-100 dark:bg-gray-700 rounded-lg p-3 max-w-[80%]">
            <p class="text-sm text-gray-800 dark:text-gray-200">
              Hi there! How can we help you today?
            </p>
          </div>
        </div>
      </div>

      <!-- Input Area -->
      <div class="p-4 border-t border-gray-200 dark:border-gray-700">
        <form @submit.prevent="sendMessage" class="flex gap-2">
          <input
            v-model="message"
            type="text"
            placeholder="Type your message..."
            class="flex-1 px-4 py-2 rounded-full border border-gray-200 dark:border-gray-600 bg-white dark:bg-gray-900 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          <button
            type="submit"
            class="px-4 py-2 bg-blue-600 text-white rounded-full hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            Send
          </button>
        </form>
      </div>
    </div>

    <!-- FAB Button -->
    <button
      @click="toggleChat"
      class="w-16 h-16 bg-blue-600 hover:bg-blue-700 rounded-full shadow-lg flex items-center justify-center text-white transition-colors relative"
    >
      <span class="text-2xl">{{ isOpen ? '✕' : '💬' }}</span>
      
      <!-- Notification Dot -->
      <span
        v-if="!isOpen"
        class="absolute -top-1 -right-1 w-4 h-4 bg-red-500 rounded-full border-2 border-white dark:border-gray-900"
      ></span>
    </button>
  </div>
</template>